<template>
    <v-layout wrap row>
        <v-flex xs12
                v-if="event.additional_info.length>0"
                d-flex
        >
            <v-card color="primary" dark>
                <v-card-text v-html="event.formatted_additional_info">
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "AdditionalInfo",
        props: {
            event: Object
        }
    }
</script>

<style scoped>

</style>
